/* eslint-disable import/no-cycle */
import api from './api.service';

function index(propagandistId, params) {
  return api.get(`/propagandists/${propagandistId}/schools`, params);
}

function get(propagandistId, id, params) {
  return api.get(`/propagandists/${propagandistId}/schools/${id}`, params);
}

function create(propagandistId, params) {
  return api.post(`/propagandists/${propagandistId}/schools`, params);
}

function update(propagandistId, id, params) {
  return api.put(`/propagandists/${propagandistId}/schools/${id}/update`, params);
}

function remove(propagandistId, id, params) {
  return api.delete(`/propagandists/${propagandistId}/schools/${id}`, params);
}

function save(params) {
  return (params.id)
  ? update(params.propagandist_id, params.id, params)
  : create(params.propagandist_id, params);
}


export const propagandistsSchoolsService = {
  index,
  get,
  create,
  update,
  remove,
  save,
};
